/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTemplate } from './message-template';
import {
    MessageTemplateFromJSON,
    MessageTemplateFromJSONTyped,
    MessageTemplateToJSON,
    MessageTemplateToJSONTyped,
} from './message-template';

/**
 * 
 * @export
 * @interface MessageTemplatePaginatedResponse
 */
export interface MessageTemplatePaginatedResponse {
    /**
     * Indicates if there are more pages to fetch.
     * @type {boolean}
     * @memberof MessageTemplatePaginatedResponse
     */
    hasMore: boolean;
    /**
     * Total number of elements across all pages.
     * @type {number}
     * @memberof MessageTemplatePaginatedResponse
     */
    totalElements: number | null;
    /**
     * The maximum number of elements in this page.
     * @type {number}
     * @memberof MessageTemplatePaginatedResponse
     */
    limit: number | null;
    /**
     * List of message templates.
     * @type {Array<MessageTemplate>}
     * @memberof MessageTemplatePaginatedResponse
     */
    messageTemplates: Array<MessageTemplate>;
    /**
     * The offset of the first element in this page (for offset-based pagination). Either offset or last_sequence must be set.
     * @type {number}
     * @memberof MessageTemplatePaginatedResponse
     */
    offset?: number | null;
    /**
     * The sequence (or key) of the last element in this page (for key-based pagination). Either offset or last_sequence must be set.
     * @type {number}
     * @memberof MessageTemplatePaginatedResponse
     */
    lastSequence?: number | null;
}

/**
 * Check if a given object implements the MessageTemplatePaginatedResponse interface.
 */
export function instanceOfMessageTemplatePaginatedResponse(value: object): value is MessageTemplatePaginatedResponse {
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('messageTemplates' in value) || value['messageTemplates'] === undefined) return false;
    return true;
}

export function MessageTemplatePaginatedResponseFromJSON(json: any): MessageTemplatePaginatedResponse {
    return MessageTemplatePaginatedResponseFromJSONTyped(json, false);
}

export function MessageTemplatePaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageTemplatePaginatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasMore': json['has_more'],
        'totalElements': json['total_elements'],
        'limit': json['limit'],
        'messageTemplates': ((json['message_templates'] as Array<any>).map(MessageTemplateFromJSON)),
        'offset': json['offset'] == null ? undefined : json['offset'],
        'lastSequence': json['last_sequence'] == null ? undefined : json['last_sequence'],
    };
}

export function MessageTemplatePaginatedResponseToJSON(json: any): MessageTemplatePaginatedResponse {
    return MessageTemplatePaginatedResponseToJSONTyped(json, false);
}

export function MessageTemplatePaginatedResponseToJSONTyped(value?: MessageTemplatePaginatedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'has_more': value['hasMore'],
        'total_elements': value['totalElements'],
        'limit': value['limit'],
        'message_templates': ((value['messageTemplates'] as Array<any>).map(MessageTemplateToJSON)),
        'offset': value['offset'],
        'last_sequence': value['lastSequence'],
    };
}

